import React from 'react';
import { useDispatch } from 'react-redux';

import { hideModal, showModal } from 'legacy/actions/modalActions';
import { useTranslation } from 'react-i18next';

const EventQuestions = ({ requiredInfo, event, refetchTicketInfoRequired }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['events']);

  if (
    !requiredInfo?.googleForms?.required &&
    !requiredInfo?.ticketNotes?.required
  ) {
    return null;
  }

  const onClick = () => {
    const modalId = requiredInfo?.ticketNotes?.required
      ? 'TICKET_NOTES'
      : 'FILL_FORM';

    const modalProps = {
      event,
      shouldPromptBeforeClose: false,
      guestQuestions: undefined,
      onClose: () => {
        dispatch(hideModal());
      },
      onSuccess: () => {
        refetchTicketInfoRequired();
        dispatch(hideModal());
      }
    };

    if (modalId === 'TICKET_NOTES') {
      modalProps.shouldPromptBeforeClose = true;
      modalProps.guestQuestions = requiredInfo.ticketNotes.guestQuestions;
    }

    dispatch(showModal(modalId, modalProps));
  };

  return (
    <div className="mt-8 p-6 bg-secondary-500 border-1 border-secondary-500 opacity-25 rounded-2xl">
      <p className="font-normal text-sm text-gray-500 leading-relaxed">
        {t('events:eventDetails.eventRequiresAdditionalInfo')}
      </p>

      <div
        className="mt-4 text-primary-500 text-center cursor-pointer"
        onClick={onClick}
      >
        {t('events:eventDetails.fillOutRequestedInfo')}
      </div>
    </div>
  );
};

export default EventQuestions;
